import React from 'react';

import Hero from '../../components/Common/Hero/Hero';
import MetaData from '../../components/Common/MetaData/MetaData';
import ContactUs from '../../components/Common/ContactUs/ContactUs';

import GsaHeroImage from '../../assets/images/heros/gsa-hero.jpg';
import SEWP_VI from '../../assets/images/government-contracting/SEWP_VI.png';
import orderingGuide from '../../assets/documents/nasa-sewp/BNL_Consulting_NASA_SEWP_VI_Ordering_Guide.pdf';

function SewpContact({role, name, email, phone}) {
  return (
    <div className="col-md-4 col-sm-6">
      {role && (<div className={'px-3'} style={{backgroundColor: '#A8C3E5'}}>{role}</div>)}
      {name && (<div className={'px-3'}>{name}</div>)}
      {email && (<div className={'px-3'}><a style={{fontWeight: 'unset'}} href={`mailto:${email}`}>{email}</a></div>)}
      {phone && (<div className={'px-3'}>{phone}</div>)}
    </div>
  );
}

export default function GovernmentContracting() {
  return (

    <div className="NasaSewpVI">

      <MetaData
        title="NASA SEWP VI"
        description="BNL Consulting, LLC is a NASA SEWP VI Category C Contract Holder in the HUBZone Pool, giving federal agencies streamlined access to our application modernization, data, cloud, cybersecurity, and digital services."
        image={GsaHeroImage}
      />

      <Hero
        image={GsaHeroImage}
        title="NASA SEWP VI"
        detail="BNL - Ordering Guide"
        reducedFont={true}
      />

      <div className="container">

        <p className="lead pt-5 pb-3">
          BNL Consulting, LLC is a NASA SEWP VI Category C Contract Holder in the HUBZone
          Pool, giving federal agencies streamlined access to our application modernization,
          data, cloud, cybersecurity, and digital services.
        </p>

        <hr className="my-5"/>

        <div className="row">

          <div className="col-md-8 col-sm-12">
            <h2>Contract Information</h2>
            <h3 className="h5 py-2">

              <table className="table table-sm">
                <thead>
                <tr>
                  <th scope="col">Holder</th>
                  <th scope="col">BNL Consulting, LLC</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row">Number</th>
                  <td>80TECH26D1679</td>
                </tr>
                <tr>
                  <th scope="row">Category</th>
                  <td>Category C - Mission-Based ITC/AV Service Solutions</td>
                </tr>
                <tr>
                  <th scope="row">Contract Type</th>
                  <td>Government-Wide Acquisition Contract (GWAC)</td>
                </tr>
                <tr>
                  <th scope="row">Business Pool</th>
                  <td>HUBZone Small Business</td>
                </tr>
                <tr>
                  <th scope="row">Period of Performance</th>
                  <td> November 2026 through October 2036</td>
                </tr>
                <tr>
                  <th scope="row">SEWP Surcharge</th>
                  <td>0.34%</td>
                </tr>
                <tr>
                  <th scope="row">UEI</th>
                  <td>CAQAXHUHTEL3</td>
                </tr>
                </tbody>
              </table>
            </h3>
          </div>
          <div className="col-md-4 col-sm-12">
            <img
              src={SEWP_VI}
              className="mb-4 responsive-image w-75"
              alt="NASA SEWP VI"
            />

            <div/>
          </div>
        </div>


        <div className="row">
          <div className="col-sm-12">
            <h2>How to Obtain a Quote</h2>

            <div className="row">
              <div className="col-sm-9">
                Federal agencies and approved federal contractors may request information or pricing
                through the NASA SEWP online Quote Request Tool.
              </div>
            </div>

            <div className="row">
              <div className="col-sm-9">
                <ol>
                  <li>Access the NASA SEWP Quote Request Tool.</li>
                  <li>Create a Request for Quote, Market Research Request, or Request for Information.</li>
                  <li>Select the applicable Category C competition or HUBZone Small Business pool.</li>
                  <li>Include the requirements, response instructions, and applicable terms.</li>
                  <li>Identify BNL Consulting as a suggested source when permitted and appropriate.</li>
                </ol>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-9">
                For assistance with scope, preparing a request, or obtaining a quote, contact BNL's
                SEWP Program Office.
              </div>
            </div>
          </div>

          <div className="col-sm-12 py-4">
            <div className="row">
              <SewpContact
                name={'Amy Arnett'}
                role={'Program Manager'}
                email={'amy.arnett@bnl-consulting.com'}
                phone={'404-574-8634'}
              />
              <SewpContact
                name={'Rob Tabit'}
                role={'Deputy PM Manager'}
                email={'rob.tabit@bnl-consulting.com'}
                phone={'240-876-5648'}
              />
              <SewpContact
                name={'BNL SEWP Program Office'}
                role={'General Quote and Ordering Support'}
                email={'amy.arnett@bnl-consulting.com'}
                phone={'404-574-8634'}
              />
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-sm-12">
            <h2>Installation, Warranty, and Post-Delivery Support</h2>

            <div className="row">
              <div className="col-sm-9">
                <p>
                  BNL provides ordering and post-delivery support based on the requirements and terms
                  of each delivery order. Support may include installation coordination, technical and
                  software support, warranty coordination, delivery assistance, and resolution of post
                  delivery issues.
                </p>
                <p>
                  Applicable warranty, maintenance, licensing, and support terms will be identified in
                  BNL's quote or order documentation. When support is provided by a manufacturer,
                  software publisher, cloud provider, or other solution provider, BNL will coordinate with
                  that provider to help resolve the issue.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <h2>Resolving Order Problems</h2>

            <div className="row">
              <div className="col-sm-9">
                <p>
                  For assistance with a quote, order, delivery, invoice, warranty, or post-delivery issue,
                  contact the BNL SEWP Program Manager or Deputy Program Manager and provide:
                </p>

              </div>
            </div>
            <div className="row">
              <div className="col-sm-9">
                <ul>
                  <li>Agency and customer point of contact</li>
                  <li>SEWP Tracking Number, if available</li>
                  <li>Delivery order or purchase order number</li>
                  <li>Description of the issue and requested resolution</li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-9">
                <p>
                  BNL will review the issue, coordinate with the appropriate team or solution provider, and
                  keep the customer informed through resolution.
                </p>

              </div>
            </div>
            <div className="row">
              <div className="col-sm-9">
                For additional assistance, contact the NASA SEWP Program Management Office:
              </div>
            </div>
            <div className="row">
              <div className="col-sm-9">
                <p>
                  <div><strong>Hours:</strong> Monday-Friday, 7:30 a.m.-6:00 p.m. Eastern Time</div>
                  <div><strong>Email:</strong> help@sewp.nasa.gov</div>
                  <div><strong>Customer Help Desk:</strong> (301) 286-1478</div>
                  <div><strong>Website:</strong> <a href={'www.sewp.nasa.gov'}>www.sewp.nasa.gov</a></div>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <h2>A.1.1.3 Fair Opportunity and Requests for Quotes </h2>

            <div className="row">
              <div className="col-sm-9">
                <p>
                  Excerpt from BNL Consulting’s NASA SEWP VI Terms and Conditions contract clause A.1.1.3
                </p>
                <p>
                  The Contractor shall not market, quote or otherwise offer for sale, any IT Solutions not listed under this contract, until the said
                  solutions are included in the SEWP database of record, and available to all Government end-users.
                </p>
                <p>
                  If the Government issues a Request For Information (RFI) as part of market research, the Contractor may provide items not yet
                  listed on their SEWP contract as part of a market research quote if:
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-9">
                <ol>
                  <li>All such items are clearly marked as not yet available on their SEWP contract; and</li>
                  <li>The contractor submits a technology refreshment request to add those products to their contract. </li>
                </ol>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-9">
                <p>
                  If the Government issues a Request For Quote (RFQ) or a Market Research Request (MRR),
                  the Contractor may only respond with items available on their Contract and the price of each
                  item shall be no greater than the price in Attachment F SEWP database of record at the time
                  the quote is issued. If the Contractor has insufficient items on their contract to fully respond
                  to the Formal RFQ, the Contractor must respond with a No Bid.
                </p>
                <p>
                  Unless the RFQ specifically allows for partial quotes, the Contractor must respond fully to all
                  requirements specified in the RFQ.
                </p>
                <p>
                  When submitting a quote to a government end-user, the contractor must clearly state the
                  length of time the quote is valid. The contractor shall honor any order submitted within the
                  stated time period of a quote.
                </p>
                <p>
                  When responding to an RFI or RFQ issued from the NASA SEWP RFQ online quoting system,
                  the Contractor must respond as outlined in Attachment C: Contract Holder User Manual.
                </p>
                <p>
                  Contract Holders are prohibited from using Government information posted on the NASA
                  SEWP Contract Holder Only Page, such as RFQs and RFIs, for purposes other than proposing
                  on SEWP requirements. This includes providing third parties with SEWP information and
                  requirements for the purpose of assisting companies that are not SEWP Contract Holders
                  with providing unsolicited proposals to meet agency requirements already posted to the
                  NASA SEWP RFQ online quoting system.
                </p>
              </div>
            </div>
          </div>
        </div>


        <div className="my-5"/>

        <div className="row">
          <div className="col-sm-12">
            <h2>Additional Links </h2>

            <div className="row">
              <div className="col-sm-9">
                <div>
                  <a href={orderingGuide} target="_blank" rel="noreferrer">Export Ordering Guide</a>
                </div>
                <div>
                  <a href={'www.sewp.nasa.gov'}>www.sewp.nasa.gov</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContactUs>
        Looking to partner on an upcoming opportunity?
      </ContactUs>;

    </div>
  );
}
